import React from "react";

const Stepper = ({ steps, currentStep, setStep, touchEnabled = true }) => {
  return (
    <div className="flex md:flex-wrap max-w-xl mx-auto md:justify-evenly items-around py-4">
      {steps.map((step, index) => (
        <div
          key={index}
          className="flex flex-col items-center sm:w-1/4 md:w-1/6 lg:w-1/8 p-1 md:p-2"
        >
          <div
            className={`flex items-center justify-center w-10 h-10 text-white rounded-full cursor-pointer 
              ${currentStep === index ? "bg-green-400" : "bg-blue-400"}`}
            onClick={() =>
              touchEnabled && typeof setStep === "function" && setStep(index)
            }
            aria-current={currentStep === index ? "step" : undefined}
          >
            {index + 1}
          </div>
          <div className="mt-2 text-center text-base md:text-lg text-[#1F2937] text-wrap hidden md:flex">
            {step}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Stepper;
